<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<!--div class="card" *ngIf="translations && globalUserPreferences?.securitySelected?.storeId != null"-->
<div class="card">
    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- LANGUAGE FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT COORDINACIÓN ID -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">

                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_coordination}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedCoordination">
                        </div>
                    </div>


                    <!-- INPUT PERIOD -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_period}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="periods" formControlName="selectedPeriod"
                                placeholder="{{translations.lbl_select}} {{translations.lbl_period}}"
                                optionLabel="descrip" [showClear]="true" [filter]="true"></p-dropdown>
                        </div>
                    </div>

                    <!-- INPUT GUIDE -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_guide}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedGuide">
                        </div>
                    </div>
                </div>

            </p-panel>
        </div>


    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView>

        <!-- TAB PANEL FII -->
        <p-tabPanel [header]="'Ingreso'">
            <p-table #dt2 [columns]="colsO" [value]="dataO" [paginator]="true" [rows]="40"
                [showCurrentPageReport]="false" [globalFilterFields]="colsGlI" responsive="true">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-plus" (click)="editOrNewOffer(null)"
                                class="p-m-2" pTooltip="{{translations.lbl_new_record}}"
                                tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataO,colsFiI,'GuideOffer')" class="p-button-warning p-m-2"
                                pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataO,colsFiI,'GuideOffer')" class="p-button-success p-m-2 z-5"
                                pTooltip="XLS" tooltipPosition="bottom"></button>

                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt2.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th [pSortableColumn]="col.field">
                                {{ capitalizeLastElement(col.header) }}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <td>
                                {{ getNestedValue(rowData, col.field) }}
                            </td>
                        </ng-container>

                        <td>
                            <button pButton pRipple icon="pi pi-play" icon="pi pi-pencil"
                                class="p-button-rounded p-button-warning p-mr-2" (click)="editOrNewOffer(rowData)"
                                pTooltip="{{translations.lbl_edit}}" tooltipPosition="bottom"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2"
                                (click)="confirmDeleteOffer(rowData)" tooltipPosition="bottom"
                                pTooltip="{{translations.lbl_delete_record}}"></button>
                        </td>

                    </tr>

                </ng-template>



                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataO != null ? dataO.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>



    </p-tabView>
</div>

<p-dialog header="Ofrenda" [(visible)]="displayModalOfferExists" styleClass="p-fluid" [modal]="true"
    [style]="{width: '50vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <!-- INFO -->
            <div class="p-col-12">
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{selectedOffer != null ? selectedOffer.descSerType : ""}} </span>
                </div>
                <div class="subTitle p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{selectedOffer != null ? selectedOffer.descWeekDay : ""}} - {{selectedOffer != null ?
                        selectedOffer.fromTime : ""}}</span>
                </div>
            </div>
        </div>

        <!-- INPUTS -->
        <div class="p-grid">

            <div class="p-col-12 p-md-12 p-sm-12">
                <div class="p-fluid">

                    <!-- WorkShop -->
                    <label for="usernameExists">{{translations.lbl_workshop}}</label>
                    <span class="p-input-icon-left">
                        <p-dropdown id="coordination_catalog_adr" [options]="listWorkShopsByGuide"
                            [(ngModel)]="selectedWorkShopsByGuide"
                            placeholder="{{translations.lbl_select}}  {{translations.lbl_workshop}}"
                            optionLabel="descrip" [showClear]="true"></p-dropdown>

                    </span>
                    <br />

                    <!-- Date -->
                    <label for="usernameExists">{{translations.lbl_date}}</label>
                    <span class="p-input-icon-left">
                        <!--i class="pi pi-calendar"></i-->
                        <!--input id="usernameExists" [disabled]="true" type="text" pInputText placeholder="{{translations.lbl_name}}"
                            [(ngModel)]="offerExists?.guideAddr?.guide.name" /-->
                        <p-inputMask id="dateExists" slotChar="dd/mm/yyyy" mask="99/99/9999"
                            [(ngModel)]="offerExists.fullDate" placeholder="DD/MM/YYYY"></p-inputMask>
                    </span>
                    <br />

                    <!-- Amount -->
                    <label for="lastnameExists">{{translations.lbl_amount}}</label>
                    <span class="p-input-icon-left">
                        <!--i class="pi pi-dollar"></i-->
                        <!--input id="lastnameExists"  type="text" pInputText placeholder="{{translations.lbl_amount}}"
                            [(ngModel)]="offerExists?.guideAddr?.guide.lastName" /-->
                        <p-inputNumber [(ngModel)]="offerExists.incExpAmt" inputId="currency-us" mode="currency"
                            currency="USD" locale="en-US"></p-inputNumber>
                    </span>
                    <br />

                    <!-- Envelop -->
                    <label for="lastnameExists">{{translations.lbl_no_envelopes}}</label>
                    <span class="p-input-icon-left">
                        <!--i class="pi pi-envelope"></i-->
                        <!--input id="lastnameExists"  type="text" pInputText placeholder="{{translations.lbl_envelopment}}"
                            [(ngModel)]="offerExists?.guideAddr?.guide.lastName" /-->
                        <p-inputNumber [(ngModel)]="offerExists.checkNum" mode="decimal" inputId="withoutgrouping"
                            placeholder="{{translations.lbl_envelopment}}">
                        </p-inputNumber>
                    </span>
                    <br />

                    <!-- Comments -->
                    <label for="comments">{{translations.lbl_comments}}</label>
                    <span class="p-input">
                        <!--i class="pi pi-send"></i-->
                        <input pInputText id="comments" type="text" pInputText
                            placeholder="{{translations.lbl_comments}}" [(ngModel)]="offerExists.concept" />
                    </span>
                    <br />

                </div>
            </div>

            <!--div class="p-col-12 p-md-6 p-sm-12">
                <div class="p-fluid">
                   
                    <label for="dateExists">Importe</label>
                    <span class="p-input-icon-left">
                        <p-inputMask [disabled]="true" id="dateExists" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            [(ngModel)]="formattedDateExists" placeholder="DD/MM/YYYY"></p-inputMask>
                    </span>
                    <br />

                    
                    <label for="genderExists">Comentarios</label>
                    <span class="p-input-icon-left">
                        <i class="pi pi-users"></i>
                        <input id="genderExists" [disabled]="true" type="text" pInputText placeholder="{{translations.lbl_gender}}"
                            [(ngModel)]="formattedGenderExists" />
                    </span>
                    <br />
                </div>
            </div-->

        </div>
    </div>
    <ng-template pTemplate="footer">

        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayModalOfferExists = false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_save}}"
            class="p-button-raised p-button-success" (click)="createUpdateOffer()"></button>
    </ng-template>
</p-dialog>